var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep6Walkthrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 180,
    viewBox: "0 0 148 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_7049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.228 119.802V92.9699C134.053 88.273 130.507 88.0519 128.662 83.5913C126.801 79.1156 129.173 76.4163 135.158 63.8201L116.18 44.8494C103.751 50.7587 100.915 53.2139 96.4011 51.3458C91.9405 49.493 91.6889 45.8941 87.0301 32.7793H60.1906C55.5013 45.9322 55.2802 49.493 50.812 51.3458C46.199 53.2673 43.4312 50.7358 31.0408 44.8494L12.0701 63.8201C18.0633 76.424 20.427 79.1155 18.5665 83.599C16.7137 88.0595 13.1605 88.2883 0 92.9699V119.809C13.1224 124.468 16.7137 124.72 18.5665 129.18C20.4346 133.687 18.0709 136.34 12.0701 148.952L31.0408 167.922C43.3016 162.097 46.1914 159.497 50.812 161.426C55.2802 163.279 55.5013 166.824 60.1906 179.992H87.0225C91.6737 166.916 91.9253 163.286 96.4544 161.395C101.022 159.504 103.729 162.005 116.18 167.907L135.158 148.936C129.18 136.363 126.801 133.649 128.662 129.165C130.499 124.712 134.06 124.483 147.228 119.794V119.802ZM73.6104 137.057C56.6679 137.057 42.9356 123.324 42.9356 106.382C42.9356 89.4396 56.6679 75.7072 73.6104 75.7072C90.5528 75.7072 104.285 89.4396 104.285 106.382C104.285 123.324 90.5528 137.057 73.6104 137.057Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18 44.8418C114.548 45.6195 113.092 46.3286 111.765 46.9844L95.2344 84.6283C99.0316 88.4026 101.837 93.1605 103.256 98.4903L132.474 61.1361L116.18 44.8418Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2848 102.852L66.1533 118.048L67.0836 88.4483L86.3744 83.3625L91.2848 102.852Z",
    fill: "#2A618D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.721 16.157L119.443 5.73385L121.502 2.17304C122.714 0.0762024 125.36 -0.61766 127.411 0.617567L137.255 6.55733C139.306 7.79256 139.985 10.4994 138.78 12.5962L136.721 16.157Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3228 102.867L67.1367 88.2729L113.938 7.19775C115.12 5.15428 117.697 4.47567 119.695 5.6804L136.637 15.9053C138.635 17.1101 139.306 19.7483 138.124 21.7917L91.3228 102.867Z",
    fill: "#0D5263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1457 99.7483L72.4438 91.4829L121.38 6.70215L135.09 14.9675L86.1457 99.7483Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4736 107.861L66.1533 118.056L75.6615 112.299C73.5952 110.393 69.7065 108.616 66.4736 107.861Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6348 86.016C80.8845 83.2635 74.6169 87.8384 74.6169 87.8384C74.6169 87.8384 73.9459 84.5216 72.1998 83.7362C70.4537 82.9508 67.1445 88.2272 67.1445 88.2272L79.6569 100.404L91.2391 102.76C91.2391 102.76 93.8087 98.0938 93.0309 96.9653C92.2532 95.8369 88.5018 96.7442 88.5018 96.7442C88.5018 96.7442 91.3535 89.3405 85.6348 86.016Z",
    fill: "#2A618D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_7049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147.228,
    height: 180,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6Walkthrough);
export default __webpack_public_path__ + "static/media/step_6_walkthrough.c73ba7a5fb16bf7677680e85288b2501.svg";
export { ForwardRef as ReactComponent };